import { IconDefinition } from "./types";

const creditCard: IconDefinition = {
  iconName: "credit-card",
  width: 512,
  height: 512,
  svgPathData:
    "M464 112l0 48-416 0 0-48 416 0zm0 112l0 176-416 0 0-176 416 0zM48 64l-48 0 0 384 512 0 0-384-464 0zM80 320l0 48 96 0 0-48-96 0zm144 0l0 48 112 0 0-48-112 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "credit-card",
  unicode: 0xf09d,
};

export { creditCard };
